export const DEEP_LINK_BASE_URL = window.document.URL.includes('d1q1chclchjxl4')
  ? 'https://tinyurl.com/koltorah1'
  : 'https://tinyurl.com/kol-torah-2';
